import { Link } from "react-router-dom";

export default function Logo({ variant = "dark", className = "" }) {
  const textColor = variant === "dark" ? "text-[#07111F]" : "text-white";
  return (
    <Link to="/" data-testid="logo-link" className={`group inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/dijitalroket-icon.png"
        alt="Dijital Roket"
        className="h-9 w-9 object-contain transition-transform duration-300 group-hover:scale-105"
      />
      <span className="flex flex-col leading-none">
        <span className={`font-heading text-lg font-extrabold tracking-tight whitespace-nowrap ${textColor}`}>Dijital Roket</span>
        <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-[#F97316]">DR AI</span>
      </span>
    </Link>
  );
}
